import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MacroFavoriteService {
  private readonly apiUrl = 'api/UserMacroFavorite';

  constructor(private http: HttpClient) {}

  getFavorites(): Promise<string[]> {
    const url = `${this.apiUrl}/GetFavorites`;
    return lastValueFrom(this.http.get<string[]>(url) as any);
  }

  addFavorite(macroName: string): Promise<void> {
    const url = `${this.apiUrl}/AddFavorite`;
    return lastValueFrom(this.http.post<void>(url, { macroName }) as any);
  }

  removeFavorite(macroName: string): Promise<void> {
    const url = `${this.apiUrl}/RemoveFavorite`;
    return lastValueFrom(this.http.post<void>(url, { macroName }) as any);
  }
}
